module.exports = __webpack_public_path__ + "static/img/6401_phase_function_Paper_PointsHejduk_Prediction.3397ddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6401_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Dm2m
// module chunks = 0